import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { Card, Typography } from "@mui/material";
import { OrderData } from "../types/dashboardTypes";

interface Props {
  orders: OrderData[];
  timeRange: string;
}

const RevenueChart = ({ orders, timeRange }: Props) => {
  const chartData = orders.map((order) => ({
    date: new Date(order.Orderdate).toLocaleDateString(),
    revenue: parseFloat(order.totalAmount) || 0,
  }));

  return (
    <Card className="saloon-chart-card">
      <Typography variant="h6" gutterBottom>
        Revenue Over Time ({timeRange})
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="revenue" stroke="#8884d8" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default RevenueChart;
